export default __webpack_public_path__ + "images/e2c18b3e94f09df167c2e488e3b43936.png";